<script>
export default {
  name: 'BasePopover',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <div v-if="disabled">
    <slot />
  </div>
  <el-popover
    v-else
    popper-class="tamara-base-popover"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
    <template v-slot:reference>
      <slot name="reference" />
    </template>
  </el-popover>
</template>

<style lang="scss">
.tamara-base-popover.el-popover.el-popper {
  padding: 0;
  overflow: hidden;
  background-color: transparent;
  border: none;
  border-radius: 8px;
}
</style>
